import React from "react";
import { Link } from "react-router-dom";

const CHAINS = [
  ["bitcoin",      "Bitcoin"],
  ["ethereum",     "Ethereum"],
  ["solana",       "Solana"],
  ["bsc",          "BNB Chain"],
  ["polygon",      "Polygon"],
  ["arbitrum",     "Arbitrum"],
  ["optimism",     "Optimism"],
  ["base",         "Base"],
  ["litecoin",     "Litecoin"],
  ["bitcoin-cash", "Bitcoin Cash"],
  ["dogecoin",     "Dogecoin"],
  ["tron",         "Tron"],
  ["osmosis",      "Osmosis"],
  ["celestia",     "Celestia"],
  ["sei",          "Sei"],
  ["injective",    "Injective"],
  ["aptos",        "Aptos"],
  ["sui",          "Sui"],
];

export default function ChainMarquee({ size = 44, gap = 36, source = "marquee" }) {
  // Render the list TWICE so the CSS keyframe loop is seamless.
  const items = [...CHAINS, ...CHAINS];
  return (
    <div data-testid="chain-marquee"
         style={{
           overflow: "hidden", maskImage: "linear-gradient(to right, transparent, #000 12%, #000 88%, transparent)",
           WebkitMaskImage: "linear-gradient(to right, transparent, #000 12%, #000 88%, transparent)",
         }}>
      <div className="qt-marquee" style={{ display: "flex", gap, alignItems: "center", whiteSpace: "nowrap", padding: "12px 0" }}>
        {items.map(([id, label], i) => (
          <Link key={`${id}-${i}`}
                to={`/free-scan?chain=${id}&utm_source=${source}-${id}`}
                title={`Run a free PQC scan on ${label}`}
                data-testid={`marquee-link-${id}`}
                className="qt-marquee-link flex items-center gap-3 shrink-0">
            <img src={`/chains/${id}.png`} alt={label} width={size} height={size}
                 style={{ display: "block", filter: "drop-shadow(0 2px 8px rgba(0,0,0,0.3))" }} />
            <span className="qt-mono text-xs"
                  style={{ color: "var(--qt-text-3)", letterSpacing: "0.12em", textTransform: "uppercase" }}>
              {label}
            </span>
          </Link>
        ))}
      </div>
      <style>{`
        .qt-marquee { animation: qt-mq 60s linear infinite; width: max-content; }
        .qt-marquee:hover { animation-play-state: paused; }
        .qt-marquee-link {
          padding: 6px 10px;
          border-radius: 8px;
          transition: background-color .15s, transform .15s;
          text-decoration: none;
        }
        .qt-marquee-link:hover {
          background: rgba(0, 229, 255, 0.08);
          transform: translateY(-1px);
        }
        .qt-marquee-link:hover span {
          color: var(--qt-cyan) !important;
        }
        @keyframes qt-mq {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }
        @media (prefers-reduced-motion: reduce) {
          .qt-marquee { animation: none; transform: translateX(-25%); }
        }
      `}</style>
    </div>
  );
}
